import React,
{
  useCallback,
  useEffect,
  useMemo,
  useState 
} from 'react'

import { EmptyState } from '@driftt/crm-components'
import { Div } from '@driftt/tide-core'
import { Table } from '@driftt/tide-table'
import { getPardotSyncErrors } from 'api/imports'
import Paginator from 'components/Paginator'

import {
  Columns,
  RowFormatter 
} from '../PardotTableFormatters'

import './style.css'

const PardotImportLogs = ({
  orgId,
  history 
}) => {
  const [syncErrorList, setSyncErrorList] = useState([])
  const [totalErrors, setTotalErrors] = useState(0)
  const [index, setIndex] = useState(0)
  const [currentPage, setCurrentPage] = useState(0)
  const [currentSize, setCurrentSize] = useState(25)
  const [isLoading, setIsLoading] = useState(true)


  const getPardotErrors = useCallback(() => {
    async function fetch() {
      try {
        const { data: erroredSyncs } = await getPardotSyncErrors({
          orgId,
          startFrom: index,
          size: currentSize 
        })
        setSyncErrorList(erroredSyncs.data)
        setTotalErrors(erroredSyncs.total)
        setIsLoading(false)
      } catch(e) {
        console.warn(e)
      }
    }
    fetch()
  },[orgId, index, currentSize])

  const nextPage = () => {
    setCurrentPage(currentPage + 1)
    setIndex(index + currentSize)
  }

  const previousPage = () => {
    setCurrentPage(currentPage - 1)
    setIndex(index - currentSize)
  }

  const changeSize = ({ value }) => {
    setCurrentSize(value)
  }

  useEffect(() => getPardotErrors(), [index, currentSize, getPardotErrors])

  const totalPages = useMemo(() => Math.ceil(totalErrors / currentSize),[totalErrors, currentSize])

  if (syncErrorList.length === 0 && !isLoading) {
    return (
      <EmptyState
        history={history}
        topText="No logs to show for Pardot" 
        bottomText="Try importing some lists from Pardot!" 
        ctaText="Import a Pardot List"
        ctaUrl="/imports/pardot"
      />
    )
  }

  return (
    <Div className="pardot-sync-logs--container">
      <Table 
        className="pardot-sync-logs--table"
        columns={Columns}
        isWorking={isLoading}
        data={!!syncErrorList && syncErrorList.map(RowFormatter)}
      />
      {!isLoading && <Paginator goForward={nextPage} changeSize={changeSize}
        goBackward={previousPage} totalPages={totalPages}
        index={currentPage} size={currentSize} />}
    </Div>
  )
}


export default PardotImportLogs
